import React from 'react';

import Header from 'app/components/Header';

export interface LayoutProps extends React.ComponentProps<any> {
  backURL?: string;
}

const Layout = ({ backURL = '', children }: LayoutProps) => (
  <div
    className="min-h-screen dark:bg-dark transition-all"
    data-testid="layout-component"
  >
    <Header backURL={backURL} />
    <main className="w-full h-full p-6">{children}</main>
  </div>
);

export default Layout;
